"use strict";
'app public';

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _flags = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/flags"));
require("@/res/globalStyle.css");
var _tinycon = _interopRequireDefault(require("tinycon"));
var _StateBrowser = _interopRequireDefault(require("@/components/StateBrowser"));
var _AppSettings = _interopRequireDefault(require("@/components/AppSettings"));
var _Container = _interopRequireDefault(require("@/components/Container"));
var _ControlInput = _interopRequireDefault(require("@/components/ControlInput"));
var _MediaViewer = _interopRequireDefault(require("@/components/MediaViewer"));
var _UserAvatarCommon = _interopRequireDefault(require("@/components/UserAvatarCommon"));
var _CguModal = _interopRequireDefault(require("@/components/CguModal"));
var _Sidebar = require("@/components/Sidebar");
var _ThemeManager = _interopRequireDefault(require("@/libs/ThemeManager"));
var Notifications = _interopRequireWildcard(require("@/libs/Notifications"));
var bufferTools = _interopRequireWildcard(require("@/libs/bufferTools"));
var _Logger = _interopRequireDefault(require("@/libs/Logger"));
var _GlobalApi = _interopRequireDefault(require("@/libs/GlobalApi"));
var _Html = _interopRequireDefault(require("@/libs/renderers/Html"));
var _MessageParser = _interopRequireDefault(require("@/libs/MessageParser"));
var Misc = _interopRequireWildcard(require("@/helpers/Misc"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
let log = _Logger.default.namespace('App.vue');
var _default = exports.default = {
  components: {
    StateBrowser: _StateBrowser.default,
    Container: _Container.default,
    ControlInput: _ControlInput.default,
    MediaViewer: _MediaViewer.default,
    AvatarCommon: _UserAvatarCommon.default,
    CguModal: _CguModal.default
  },
  props: ['startupComponent'],
  data() {
    return {
      hasStarted: false,
      // When on mobile screens, the statebrowser turns into a drawer
      stateBrowserDrawOpen: false,
      // Onglet du tiroir statebrowser sur mobile : 'channels' (Salons, ouvert par
      // le burger) ou 'queries' (Privés, ouvert par « Messages »). Synchronisé
      // depuis StateBrowserNetwork via l'event 'statebrowser.tab.changed'.
      statebrowserTab: 'channels',
      // If set, will become the main view instead of a buffer/nicklist container
      activeComponent: null,
      activeComponentProps: {},
      // If set, will become the main view when no networks are available to be shown
      // and there is no active component set
      fallbackComponent: null,
      fallbackComponentProps: {},
      mediaviewerOpen: false,
      mediaviewerUrl: '',
      mediaviewerComponent: null,
      mediaviewerComponentProps: {},
      mediaviewerIframe: false,
      sidebarState: new _Sidebar.State(),
      channelUserCount: 0,
      whoLoadedMap: {},
      // Boutons de plugins du header canal (report, block sound/mp, taille police…)
      // déplacés depuis ContainerHeader vers la navbar.
      pluginUiChannelElements: _GlobalApi.default.singleton().channelHeaderPlugins,
      // Auto-absence : vrai quand on a nous-mêmes marqué l'utilisateur "Absent"
      // suite à une perte de focus de la page.
      autoAwayActive: false,
      autoAwayTimer: null,
      autoBackTimer: null,
      // Alerte dynamique (toast) : message transitoire affiché quelques secondes.
      alertMessage: '',
      alertTimer: null,
      // Mode d'affichage clair/sombre (bascule topbar). Valeur réelle posée
      // par initColourMode() (created) depuis localStorage ; défaut sombre.
      colourMode: 'dark',
      // Modal CGU : vrai une fois les conditions acceptées (persisté en
      // localStorage → posé par initCguAccepted() dans created()).
      cguAccepted: false
    };
  },
  computed: {
    networks() {
      return this.$state.networks;
    },
    network() {
      return this.$state.getActiveNetwork();
    },
    buffer() {
      return this.$state.getActiveBuffer();
    },
    // Modal CGU : gate obligatoire affiché une fois l'utilisateur connecté à
    // l'app (hasStarted), tant qu'il n'a pas accepté les conditions.
    // ⚠️ On s'efface tant qu'un mediaviewer est ouvert — notamment le dialogue
    // NickServ (identification d'un pseudo enregistré), rendu à un z-index
    // inférieur : sinon le CGU (overlay plein écran qui bloque les clics) le
    // recouvrait → impossible de s'identifier. Le dialogue passe d'abord, le
    // CGU réapparaît une fois l'identification fermée.
    shouldShowCgu() {
      return this.hasStarted && !this.cguAccepted && !this.mediaviewerOpen;
    },
    // Vrai quand la vue active est la liste des radios (plugin-radio via
    // showView("RadioStations")). Sert à rendre le chat DERRIÈRE ce modal —
    // comme le modal profil — au lieu de le remplacer (contrairement aux vues
    // plein écran Paramètres / Réseau qui, elles, doivent bien masquer le chat).
    isRadioModal() {
      if (!this.activeComponent) {
        return false;
      }
      const tabs = _GlobalApi.default.singleton().tabs;
      return !!(tabs && tabs.RadioStations && this.activeComponent === tabs.RadioStations.component);
    },
    // Onglet actif de la barre de navigation mobile (état visuel des boutons).
    mobileTab() {
      if (this.stateBrowserDrawOpen) {
        return 'messages';
      }
      const section = this.sidebarState.section();
      if (section === 'nicklist') {
        return 'nicklist';
      }
      if (section === 'user') {
        return 'profil';
      }
      return 'salon';
    },
    currentThemeName() {
      const theme = _ThemeManager.default.instance().currentTheme();
      return theme ? theme.name.toLowerCase() : '';
    },
    activeBufferKey() {
      if (!this.buffer) {
        return '';
      }
      return `${this.buffer.networkid}:${this.buffer.name.toLowerCase()}`;
    },
    appName() {
      // Nom de l'app (marque). Centralisé : réglage config `windowTitle`,
      // défaut « AppChat ». (Le logo CSS du formulaire utilise --app-name.)
      return this.$state.setting('windowTitle') || 'AppChat';
    },
    topbarTitle() {
      // Nom du salon (ou pseudo en privé) affiché dans la topbar ; fallback
      // sur le nom de l'app s'il n'y a pas de buffer actif.
      return this.buffer ? this.buffer.name : this.appName;
    },
    unreadMessages() {
      // Badge du burger : ne compter QUE les salons (channels). On exclut le
      // buffer serveur (notices/numerics système) et les privés — c'est « les
      // autres messages système » que l'utilisateur ne veut pas voir comptés.
      let count = 0;
      let highlight = false;
      this.$state.networks.forEach(network => {
        network.buffers.forEach(buffer => {
          if (!buffer.isChannel || !buffer.isChannel()) {
            return;
          }
          count += (0, _flags.default)(buffer).unread || 0;
          if ((0, _flags.default)(buffer).highlight) {
            highlight = true;
          }
        });
      });
      return {
        count,
        highlight
      };
    },
    // Badge "Messages" de la barre de navigation mobile : UNIQUEMENT les
    // messages privés non lus (buffers query), pas les salons.
    unreadPrivateMessages() {
      let count = 0;
      let highlight = false;
      this.$state.networks.forEach(network => {
        network.buffers.forEach(buffer => {
          if (!buffer.isQuery || !buffer.isQuery()) {
            return;
          }
          count += (0, _flags.default)(buffer).unread || 0;
          if ((0, _flags.default)(buffer).highlight) {
            highlight = true;
          }
        });
      });
      return {
        count,
        highlight
      };
    },
    shouldShowTopic() {
      // Topic du salon dans la navbar : desktop uniquement, salon avec topic,
      // et réglage GLOBAL « show_topic_bar » activé (désactivé par défaut, cf. fa-cog).
      return !this.$state.ui.is_narrow && this.buffer && this.buffer.isChannel && this.buffer.isChannel() && this.buffer.topic && this.buffer.topic.trim() && this.$state.setting('show_topic_bar');
    },
    formattedTopic() {
      if (!this.buffer) {
        return '';
      }
      let blocks = (0, _MessageParser.default)(this.buffer.topic, {
        extras: false
      });
      return (0, _Html.default)(blocks);
    },
    // Auto-connexion par URL (ex. ?nick=…&age=…&sexe=…&channel=…&go=1) :
    // on saute l'affichage du formulaire ASL et on montre directement le
    // loader de connexion. Le composant de démarrage reste monté (v-show
    // dans le template) pour que son auto-start (created → startUp) se
    // déclenche ; on le masque juste visuellement — il ne peint jamais.
    // On exige les champs requis (nick + age + sexe) : si l'URL est
    // incomplète, on laisse le formulaire s'afficher normalement pour ne
    // pas bloquer l'utilisateur sur un spinner infini.
    isAutoStarting() {
      if (this.hasStarted) {
        return false;
      }
      return !!(Misc.queryStringVal('go') && Misc.queryStringVal('nick') && Misc.queryStringVal('age') && Misc.queryStringVal('sexe'));
    },
    shouldShowPostConnectLoader() {
      if (!this.hasStarted || !this.network) {
        return false;
      }

      // Loader PLEIN ÉCRAN réservé à la connexion serveur (on n'a encore rien
      // à afficher). Le chargement d'un salon (join / WHO) est géré par
      // isChannelLoading → petit indicateur, SANS masquer la vue de l'app.
      return this.network.state !== 'connected';
    },
    isChannelLoading() {
      // Indicateur léger NON bloquant (app visible) : salon en cours de join
      // (NAMES pas encore reçu) ou WHO (âge/sexe ASL) pas encore revenu. C'est
      // le cas typique d'un reload avec 8 salons où l'on switch avant que le
      // WHO de chaque salon soit fait. whoLoadedMap est rempli par irc.wholist,
      // ou en dernier recours par le filet de sécurité armWhoTimeout (4 s).
      if (!this.hasStarted || !this.network || this.network.state !== 'connected') {
        return false;
      }
      if (!this.buffer || !this.buffer.isChannel || !this.buffer.isChannel()) {
        return false;
      }
      if (this.buffer.enabled && !this.buffer.joined) {
        return true;
      }
      if (this.buffer.joined && !this.whoLoadedMap[this.activeBufferKey]) {
        return true;
      }
      return false;
    }
  },
  watch: {
    buffer() {
      this.updateChannelUserCount();
      this.armWhoTimeout();
    }
  },
  created() {
    this.initColourMode();
    this.initCguAccepted();
    this.listenForActiveComponents();
    this.watchForThemes();
    this.initStateBrowser();
    this.initMediaviewer();
    this.configureFavicon();

    // Option A : garder le loader jusqu'à la réception du WHO (ASL) d'un salon.
    this.listen(this.$state, 'irc.wholist', (event, network) => {
      this.markWhoLoaded(event, network);
    });

    // Alerte dynamique (toast) déclenchée depuis n'importe où via $state.
    this.listen(this.$state, 'app.alert', message => {
      this.showAlert(message);
    });
    this.listen(document, 'visibilitychange', this.onVisibilityChange);
    this.listen(document, 'keydown', event => this.onKeyDown(event));
    this.listen(window, 'focus', event => this.onFocus(event));
    this.listen(window, 'blur', event => this.onBlur(event));
    this.listen(window, 'touchstart', event => this.onTouchStart(event));
    this.listen(document, 'click', event => {
      this.onDocumentClickCloseRadio(event);
      this.onDocumentClickCloseNsModal(event);
    });
  },
  mounted() {
    this.trackWindowDimensions();
    this.updateChannelUserCount();
    this.armWhoTimeout();
    // buffer.users n'est pas réactif : on rafraîchit le compteur périodiquement
    setInterval(() => this.updateChannelUserCount(), 3000);
  },
  methods: {
    // ── Thème clair / sombre ────────────────────────────────────────────
    // Le mode est porté par l'attribut data-mode sur <html> (lu par le bloc
    // :root[data-mode="light"] de theme.css). Persisté en localStorage pour
    // survivre au rechargement, appliqué dès created() (avant le rendu).
    initColourMode() {
      let mode = 'dark';
      try {
        if (window.localStorage.getItem('appchat.colourMode') === 'light') {
          mode = 'light';
        }
      } catch (e) {/* localStorage indisponible (mode privé strict) */}
      this.setColourMode(mode);
    },
    setColourMode(mode) {
      this.colourMode = mode;
      document.documentElement.setAttribute('data-mode', mode);
      try {
        window.localStorage.setItem('appchat.colourMode', mode);
      } catch (e) {/* localStorage indisponible */}
    },
    toggleColourMode() {
      this.setColourMode(this.colourMode === 'light' ? 'dark' : 'light');
    },
    // ── Modal CGU ───────────────────────────────────────────────────────
    // Acceptation persistée en localStorage : une fois validées, les CGU ne
    // sont plus redemandées (retirer cette lecture pour un affichage à
    // chaque session).
    initCguAccepted() {
      try {
        this.cguAccepted = window.localStorage.getItem('appchat.cguAccepted') === '1';
      } catch (e) {/* localStorage indisponible (mode privé strict) */}
    },
    acceptCgu() {
      this.cguAccepted = true;
      try {
        window.localStorage.setItem('appchat.cguAccepted', '1');
      } catch (e) {/* localStorage indisponible */}
    },
    updateChannelUserCount() {
      const b = this.buffer;
      this.channelUserCount = b && b.isChannel && b.isChannel() ? Object.keys(b.users || {}).length : 0;
    },
    // ── Barre de navigation mobile ──────────────────────────────────────
    // Salon : ferme les tiroirs pour afficher le chat courant.
    mobileShowChannel() {
      this.stateBrowserDrawOpen = false;
      this.sidebarState.close();
    },
    // En ligne : bascule la nicklist (re-clic → la referme, retour au chat).
    mobileShowNicklist() {
      this.stateBrowserDrawOpen = false;
      this.sidebarState.toggleNicklist();
    },
    // Messages : ouvre le tiroir des salons/privés sur la VUE PRIVÉS.
    mobileToggleMessages() {
      this.openStatebrowserTab('queries');
    },
    // Burger (topbar mobile) : simple bascule ouvert/fermé du tiroir.
    //  • Tiroir OUVERT (peu importe l'onglet affiché) → on le FERME.
    //  • Tiroir FERMÉ → on le rouvre sur le DERNIER onglet consulté (Salons ou
    //    Privés). L'onglet est "collant" : on ne le force PAS selon le buffer
    //    courant — l'utilisateur retrouve la vue qu'il avait laissée.
    mobileToggleChannels() {
      if (this.stateBrowserDrawOpen) {
        this.stateBrowserDrawOpen = false;
        return;
      }
      this.openStatebrowserTab(this.statebrowserTab);
    },
    // Ouvre le tiroir statebrowser sur l'onglet demandé ('channels' = Salons,
    // 'queries' = Privés). Si le tiroir est déjà ouvert sur cet onglet, on le
    // referme (toggle) ; sinon on l'ouvre et on bascule sur l'onglet demandé.
    openStatebrowserTab(tab) {
      if (this.stateBrowserDrawOpen && this.statebrowserTab === tab) {
        this.stateBrowserDrawOpen = false;
        return;
      }
      this.sidebarState.close();
      this.statebrowserTab = tab;
      this.$state.$emit('statebrowser.tab', tab);
      this.stateBrowserDrawOpen = true;
    },
    // Boutons d'action de la topbar : on ferme d'abord le tiroir statebrowser
    // (burger) pour éviter que le panneau sidebar s'ouvre DERRIÈRE lui sur mobile.
    toggleNicklistPanel() {
      this.stateBrowserDrawOpen = false;
      this.sidebarState.toggleNicklist();
    },
    toggleSettingsPanel() {
      this.stateBrowserDrawOpen = false;
      this.sidebarState.toggleBufferSettings();
    },
    // Ferme la liste des radios (vue active affichée par plugin-radio via
    // showView) quand on clique en dehors d'elle. On ne fait rien tant que la
    // liste n'est pas ouverte, et on ignore les clics dans la liste elle-même
    // (.p-radio-browser : sélection/fermeture) ainsi que dans le widget radio
    // (.p-radio-controls : bouton d'ouverture + commandes play/volume), sinon
    // le clic d'ouverture la refermerait aussitôt.
    onDocumentClickCloseRadio(event) {
      if (!document.querySelector('.p-radio-browser')) {
        return;
      }
      const target = event.target;
      if (target && target.closest && (target.closest('.p-radio-browser') || target.closest('.p-radio-controls'))) {
        return;
      }
      // Équivaut à app.showView(null) utilisé par le plugin pour fermer.
      _GlobalApi.default.singleton().showView(null);
    },
    onDocumentClickCloseNsModal(event) {
      // Modal NickServ (mediaviewer contenant .app-ns-button) : fermeture au
      // clic en dehors du modal, comme les autres modals. Le mediaviewer docké
      // (médias) n'a pas .app-ns-button → non affecté.
      if (!document.querySelector('.app-main-mediaviewer .app-ns-button')) {
        return;
      }
      const target = event.target;
      if (target && target.closest && target.closest('.app-main-mediaviewer')) {
        return;
      }
      this.$state.$emit('mediaviewer.hide');
    },
    markWhoLoaded(event, network) {
      // Marque les salons ayant reçu leur WHO (ASL disponible)
      if (!event || !event.users || !network) {
        return;
      }
      const seen = Object.create(null);
      event.users.forEach(u => {
        const chan = u && u.channel;
        if (chan && !seen[chan]) {
          seen[chan] = true;
          this.$set(this.whoLoadedMap, `${network.id}:${chan.toLowerCase()}`, true);
        }
      });
    },
    showAlert(message) {
      // Affiche un toast d'alerte quelques secondes.
      if (!message) {
        return;
      }
      this.alertMessage = message;
      clearTimeout(this.alertTimer);
      this.alertTimer = setTimeout(() => {
        this.alertMessage = '';
      }, 5000);
    },
    armWhoTimeout() {
      // Filet de sécurité : si le WHO ne revient pas (serveur/plugin), on
      // dévoile quand même après 4s pour ne jamais bloquer sur le loader.
      clearTimeout(this.whoTimeout);
      const key = this.activeBufferKey;
      if (!key || this.whoLoadedMap[key]) {
        return;
      }
      this.whoTimeout = setTimeout(() => {
        this.$set(this.whoLoadedMap, key, true);
      }, 4000);
    },
    // Triggered by a startup screen event
    startUp(opts) {
      log('startUp()');
      if (opts && opts.fallbackComponent) {
        this.fallbackComponent = opts.fallbackComponent;
      }
      if (opts && opts.fallbackComponentProps) {
        this.fallbackComponentProps = opts.fallbackComponentProps;
      }

      // Make sure a startup screen can't trigger these more than once
      if (!this.hasStarted) {
        this.warnOnPageClose();

        // Wait for a click or sending a message before asking for notification permission.
        // Not doing this on an input event will get it blocked by some browsers.
        let requestNotificationPermission = () => {
          this.$state.$off('document.clicked', requestNotificationPermission);
          this.$state.$off('input.raw', requestNotificationPermission);
          Notifications.requestPermission(this.$state);
          Notifications.listenForNewMessages(this.$state);
        };
        this.$state.$once('document.clicked', requestNotificationPermission);
        this.$state.$once('input.raw', requestNotificationPermission);
      }
      this.hasStarted = true;
    },
    listenForActiveComponents() {
      this.listen(this.$state, 'active.component', (component, props) => {
        // Mobile : la liste des radios s'affiche dans la sidebar (plein écran),
        // comme le searchlist ASL — pas de modal flottant. Desktop : inchangé.
        let tabs = _GlobalApi.default.singleton().tabs;
        let isRadio = component && tabs && tabs.RadioStations && component === tabs.RadioStations.component;
        if (isRadio && this.$state.ui.app_width <= 769) {
          _GlobalApi.default.singleton().showInSidebar(component, props);
          return;
        }
        this.activeComponent = null;
        if (component) {
          this.activeComponentProps = props;
          this.activeComponent = component;
        }
      });
      this.listen(this.$state, 'active.component.toggle', (component, props) => {
        if (component === this.activeComponent) {
          this.activeComponent = null;
        } else if (component) {
          this.activeComponentProps = props;
          this.activeComponent = component;
        }
      });
    },
    watchForThemes() {
      this.listen(this.$state, 'theme.change', () => {
        this.$state.clearNickColours();
      });
    },
    initStateBrowser() {
      this.listen(this.$state, 'statebrowser.toggle', () => {
        this.stateBrowserDrawOpen = !this.stateBrowserDrawOpen;
      });
      this.listen(this.$state, 'statebrowser.show', () => {
        this.stateBrowserDrawOpen = true;
      });
      this.listen(this.$state, 'statebrowser.hide', () => {
        this.stateBrowserDrawOpen = false;
      });
      // Onglet réellement affiché par StateBrowserNetwork (suivi pour que burger
      // et « Messages » sachent basculer d'onglet ou refermer le tiroir).
      this.listen(this.$state, 'statebrowser.tab.changed', tab => {
        this.statebrowserTab = tab;
      });
    },
    initMediaviewer() {
      this.listen(this.$state, 'mediaviewer.show', url => {
        let opts = {};

        // The passed url may be a string or an options object
        if (typeof url === 'string') {
          opts = {
            url: url
          };
        } else {
          opts = url;
        }
        this.mediaviewerUrl = opts.url;
        this.mediaviewerComponent = opts.component;
        this.mediaviewerComponentProps = opts.componentProps;
        this.mediaviewerIframe = opts.iframe;
        this.mediaviewerOpen = true;
      });
      this.listen(this.$state, 'mediaviewer.hide', () => {
        this.mediaviewerOpen = false;
      });
    },
    configureFavicon() {
      // favicon bubble
      _tinycon.default.setOptions({
        width: 7,
        height: 9,
        color: '#ffffff',
        background: '#b32d2d',
        fallback: true
      });
      this.$state.$watch('ui.favicon_counter', newVal => {
        if (newVal) {
          _tinycon.default.setBubble(newVal);
        } else {
          _tinycon.default.reset();
        }
      });
      this.listen(this.$state, 'message.new', event => {
        let message = event.message;
        if (!message.isHighlight || message.ignore || this.$state.ui.app_has_focus) {
          return;
        }
        this.$state.ui.favicon_counter++;
      });
    },
    trackWindowDimensions() {
      // Track the window dimensions into the reactive ui state
      let trackWindowDims = () => {
        this.$state.ui.app_width = this.$el.clientWidth;
        this.$state.ui.app_height = this.$el.clientHeight;
        this.$state.ui.is_narrow = this.$el.clientWidth <= 769;
      };
      this.listen(window, 'resize', trackWindowDims);
      trackWindowDims();
    },
    warnOnPageClose() {
      window.onbeforeunload = () => {
        if (this.$state.setting('warnOnExit')) {
          return this.$t('window_unload');
        }
        return undefined;
      };
      window.onunload = () => {
        this.$state.networks.forEach(net => {
          if (net.connection.direct && net.state === 'connected') {
            net.ircClient.raw('QUIT', this.$state.setting('quitMessage') || 'Client Closed Connection');
          }
        });
      };
    },
    emitBufferPaste(event) {
      // bail if no buffer is active, or the buffer is hidden by another component
      if (!this.$state.getActiveBuffer() || this.activeComponent !== null) {
        return;
      }

      // bail if the target is an input-like element
      if (event.target instanceof HTMLInputElement || event.target instanceof HTMLSelectElement || event.target instanceof HTMLTextAreaElement) {
        return;
      }
      this.$state.$emit('buffer.paste', event);
    },
    emitDocumentClick(event) {
      this.$state.$emit('document.clicked', event);
    },
    onTouchStart(event) {
      // Parts of the UI adjust themselves if we're known to be using a touchscreen
      this.$state.ui.is_touch = true;
    },
    onBlur(event) {
      this.$state.ui.app_has_focus = false;
      this.scheduleAutoAway();
    },
    onFocus(event) {
      this.$state.ui.app_has_focus = true;
      this.$state.ui.favicon_counter = 0;
      this.scheduleAutoBack();
    },
    scheduleAutoAway() {
      // Absence marquée après 2 min de perte de focus.
      if (this.autoBackTimer) {
        this.clearTimeout(this.autoBackTimer);
        this.autoBackTimer = null;
      }
      if (this.autoAwayActive || this.autoAwayTimer) {
        return;
      }
      this.autoAwayTimer = this.setTimeout(() => {
        this.autoAwayTimer = null;
        this.setAutoAway(true);
      }, 120000);
    },
    scheduleAutoBack() {
      // Retour "connecté" 2 s après la reprise du focus.
      if (this.autoAwayTimer) {
        this.clearTimeout(this.autoAwayTimer);
        this.autoAwayTimer = null;
      }
      if (!this.autoAwayActive || this.autoBackTimer) {
        return;
      }
      this.autoBackTimer = this.setTimeout(() => {
        this.autoBackTimer = null;
        this.setAutoAway(false);
      }, 2000);
    },
    setAutoAway(isAway) {
      // Envoie AWAY aux réseaux connectés. Guard pour éviter les envois redondants.
      if (isAway === this.autoAwayActive) {
        return;
      }
      this.autoAwayActive = isAway;
      this.$state.networks.forEach(network => {
        if (!network.ircClient || network.state !== 'connected') {
          return;
        }
        network.ircClient.raw('AWAY', isAway ? 'Absent' : '');
      });
    },
    onVisibilityChange(event) {
      const newState = document.visibilityState === 'visible';
      const buffer = this.$state.getActiveBuffer();
      if (buffer) {
        buffer.isVisible = newState;
      }
      this.$state.ui.app_is_visible = newState;
    },
    onKeyDown(event) {
      this.$state.$emit('document.keydown', event);
      let meta = false;
      if (navigator.appVersion.indexOf('Mac') !== -1) {
        meta = event.metaKey;
      } else {
        // none english languages use ctrl + alt to access extended chars
        // make sure we do not interfere with that by only acting on ctrl
        meta = event.ctrlKey && !event.altKey;
      }
      if (meta && event.key === ']') {
        // meta + ]
        let buffer = bufferTools.getNextBuffer();
        if (buffer) {
          this.$state.setActiveBuffer(buffer.networkid, buffer.name);
        }
        event.preventDefault();
      } else if (meta && event.key === '[') {
        // meta + [
        let buffer = bufferTools.getPreviousBuffer();
        if (buffer) {
          this.$state.setActiveBuffer(buffer.networkid, buffer.name);
        }
        event.preventDefault();
      } else if (meta && event.key === 'o') {
        // meta + o
        this.$state.$emit('active.component.toggle', _AppSettings.default);
        event.preventDefault();
      } else if (meta && event.key === 's') {
        // meta + s
        let network = this.$state.getActiveNetwork();
        if (network) {
          network.showServerBuffer('settings');
        }
        event.preventDefault();
      }
    }
  }
};
window._app_exports = window._app_exports || {};
if(!window._app_exports["components"]) window._app_exports["components"] = {};
window._app_exports["components"]["App"]
window._app_exports.components.App = exports.default ? exports.default : exports;
